import { render, staticRenderFns } from "./EmptyParentComponent.vue?vue&type=template&id=aa5d6014&scoped=true"
import script from "./EmptyParentComponent.vue?vue&type=script&lang=js"
export * from "./EmptyParentComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa5d6014",
  null
  
)

export default component.exports